import { CommonModule } from "@angular/common";
import { Component, effect, input, signal } from "@angular/core";
import {
	CalendarErrorRecordItem,
	CalendarErrorUserDetails
} from "@modules/global-dashboard/models/global-dashboard-interface";
import { IconModule } from "@shared/components/icon/icon.module";
import { SharedModule } from "@shared/shared.module";
import { CalendarErrorSidePanelComponent } from "../calendar-error-side-panel/calendar-error-side-panel.component";

@Component({
	selector: "app-calendar-errors-banner",
	standalone: true,
	imports: [SharedModule, CommonModule, IconModule, CalendarErrorSidePanelComponent],
	templateUrl: "./calendar-errors-banner.component.html",
	styleUrl: "./calendar-errors-banner.component.scss"
})
export class CalendarErrorsBannerComponent {
	calendarErrorCounts = input<number>(0);
	calendarTimeStamp = input<string>("");
	userEmail = input<string>("");
	calendarErrorRecords = input<CalendarErrorRecordItem[]>([]);

	toasterClosed = true;
	isToasterClosed = input<boolean>(true);
	localStorageData = JSON.parse(localStorage.getItem("CALENDAR_ERROR_USER_DETAILS") || "[]");

	openCalendarErrorSidePanel = signal<boolean>(false);

	constructor() {
		effect(() => {
			this.toasterClosed = this.isToasterClosed();
		});
	}

	ngOnInit(): void {
		this.toasterStatus();
	}

	viewDetails(): void {
		/** WILL USE TO SHOW CALENDAR ERROR SIDE PANEL */
		this.openCalendarErrorSidePanel.set(true);
	}

	closeToaster(): void {
		this.localStorageData = this.localStorageData.map((user: CalendarErrorUserDetails) =>
			user.email === this.userEmail() ? { ...user, isToasterClosed: true } : user
		);

		localStorage.setItem("CALENDAR_ERROR_USER_DETAILS", JSON.stringify(this.localStorageData));
		this.toasterStatus();
	}

	toasterStatus(): void {
		this.toasterClosed = this.localStorageData.find(
			(user: CalendarErrorUserDetails) => user.email === this.userEmail()
		)?.isToasterClosed;
	}

	itemsToDisplay(): string {
		if (this.calendarErrorCounts() > 100) {
			return "100+ items";
		}

		return this.calendarErrorCounts() > 1
			? this.calendarErrorCounts() + " items"
			: this.calendarErrorCounts() + " item";
	}
}
